import Vue from 'vue'

import {
    forEach as _forEach,
    orderBy as _orderBy,
} from 'lodash'

import CarModelModel from '@/models/CarModelModel'

import modelCarService from '@/services/modelcar.service'

// -----------------------------------------------------------------------------

const state = {
    carModels: {},
    isLoading: false,
}

const getters = {
    getCarModels: state => {
        return _orderBy(state.carModels, ['id'], ['asc'])
    },

    getCarModel: state => carModelId => {
        return state.carModels[carModelId] || null
    },
}

const mutations = {
    setCarModels(state, payload) {
        state.carModels = {}

        _forEach(payload, item => {
            const CarModel = new CarModelModel(item)

            Vue.set(state.carModels, CarModel.id, CarModel)
        })
    },

    setCarModel(state, payload) {
        const CarModel = new CarModelModel(payload)

        Vue.set(state.carModels, CarModel.id, CarModel)
    },

    setIsLoading(state, payload) {
        state.isLoading = !!payload
    },
}

const actions = {
    fetch({ commit }) {
        commit('setIsLoading', true)
        return new Promise((resolve, reject) => {
            modelCarService.getList()
                .then(response => {
                    commit('setCarModels', response.response.items)
                    commit('setIsLoading', false)

                    resolve()
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
